/* Estrani - uitschuifpaneel voor het hoofdmenu. Hoort bij
   snippets/ai-menupaneel.liquid en assets/ai-menupaneel.css.

   Het thema klapt zijn eigen submenu uit bij een klik op "Shop". Dit script
   vangt die klik af en opent in de plaats dit paneel. Werkt het script niet,
   dan blijft het uitklapmenu van het thema gewoon doen wat het altijd deed -
   de links zijn dus nooit onbereikbaar.

   Door Claude gebouwd, veilig te verwijderen. */
(function () {
  'use strict';

  var paneel = null, laatsteKnop = null;

  /* Deze markering zet het uitklapmenu van het thema uit (zie de CSS). Ze wordt
     pas gezet als dit script echt draait, zodat een bezoeker zonder JavaScript
     het gewone uitklapmenu houdt en de links altijd bereikbaar blijven. */
  document.documentElement.classList.add('ai-mp-aan');

  function vind() {
    if (!paneel || !document.body.contains(paneel)) {
      paneel = document.querySelector('[data-ai-mp]');
      /* Het paneel staat in de footer-groep. Vast positioneren werkt daar,
         maar breekt zodra een voorouder ooit een transform krijgt. Daarom
         zetten we het een keer rechtstreeks onder body. */
      if (paneel && paneel.parentElement !== document.body) document.body.appendChild(paneel);
    }
    return paneel;
  }

  function open(knop) {
    var p = vind();
    if (!p) return;
    laatsteKnop = knop || null;
    p.hidden = false;
    document.body.classList.add('ai-mp-open');
    /* De browser moet de beginstand (paneel links buiten beeld) berekend hebben
       voor we 'is-open' zetten, anders springt het paneel er zonder animatie in.
       offsetWidth opvragen dwingt die berekening af. Dat is betrouwbaarder dan
       requestAnimationFrame, want dat vuurt niet in een tabblad op de
       achtergrond - en dan bleef het paneel buiten beeld staan. */
    void p.offsetWidth;
    p.classList.add('is-open');
    setTimeout(function () {
      var eerste = p.querySelector('.ai-mp__sluit');
      if (eerste) eerste.focus();
    }, 60);
  }

  function sluit() {
    var p = vind();
    if (!p || p.hidden) return;
    p.classList.remove('is-open');
    document.body.classList.remove('ai-mp-open');
    var klaar = function () { p.hidden = true; };
    var duur = 320;
    setTimeout(klaar, duur);
    if (laatsteKnop && document.body.contains(laatsteKnop)) laatsteKnop.focus();
    laatsteKnop = null;
  }

  function isOpen() {
    var p = vind();
    return p && !p.hidden;
  }

  /* Het menu-item dat subitems heeft. Het thema rendert dat als een span met
     daarin een link en een knopje met pijltje; beide moeten het paneel openen. */
  function trigger(el) {
    if (!el.closest) return null;
    var item = el.closest('.menu-list__list-item');
    if (!item) return null;
    if (item.getAttribute('slot') === 'more') return null;   /* het overloopmenu laten we met rust */
    if (!item.querySelector('.menu-list__disclosure')) return null;
    return item;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-ai-mp-sluit]')) {
      e.preventDefault();
      sluit();
      return;
    }

    /* Binnen het paneel gewoon doorklikken naar de collectie. */
    if (t.closest('.ai-mp__paneel')) return;

    var item = trigger(t);
    if (item) {
      e.preventDefault();
      e.stopPropagation();
      open(item.querySelector('a, button'));
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) sluit();
  });

  /* Navigeren met de browserknoppen mag het paneel niet open laten staan. */
  window.addEventListener('pageshow', sluit);
})();
